import { render, staticRenderFns } from "./loadingbox.vue?vue&type=template&id=76887f08&scoped=true&"
import script from "./loadingbox.vue?vue&type=script&lang=js&"
export * from "./loadingbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76887f08",
  null
  
)

export default component.exports